'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner, ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      richColors
      className='toaster group'
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--success-bg': '#ecfdf5',
          '--success-border': '#6ee7b7',
          '--success-text': '#065f46',
          '--error-bg': '#fef2f2',
          '--error-border': '#fca5a5',
          '--error-text': '#991b1b',
          '--warning-bg': '#fffbeb',
          '--warning-border': '#fcd34d',
          '--warning-text': '#92400e',
          '--info-bg': '#eff6ff',
          '--info-border': '#93c5fd',
          '--info-text': '#1e40af'
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
